import * as React from 'react';
import { useSelector } from 'react-redux';
import { IconCommunicationCall16 } from '@cian/ui-kit-design-tokens/icons';

import { LayoutBlock } from '../../components/LayoutBlock';
import { NewbuildingActions } from '../../components/NewbuildingActions';
import { getIsFlatViewOrderEnabled } from '../../selectors/newbuilding';
import { getAgentForCallback } from '../../selectors/newbuilding/agent';
import { isCallbackAvailable } from '../../utils/requestCallback';
import { CallMeBackContainer } from '../CallMeBack';
import { FlatViewOrderButtonContainer } from '../FlatViewOrderButton';

export const NewbuildingActionsContainer = () => {
  const agent = useSelector(getAgentForCallback);
  const isFlatViewButtonAvailable = useSelector(getIsFlatViewOrderEnabled);

  if (!isCallbackAvailable(agent) && !isFlatViewButtonAvailable) {
    return null;
  }

  return (
    <LayoutBlock>
      <NewbuildingActions
        callbackButton={
          <CallMeBackContainer
            placeType="floating_block"
            buttonTheme="fill_primary"
            buttonText="Заказать звонок"
            buttonBeforeIcon={<IconCommunicationCall16 color="icon-inverted-default" />}
          />
        }
        flatViewButton={<FlatViewOrderButtonContainer />}
      />
    </LayoutBlock>
  );
};
